module.exports = __webpack_public_path__ + "static/media/icon-document.9c1f4d5e.svg";